import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

// Importar SweetAlert2
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

// Importar estilos globales
import '@/assets/styles/global.css'

// Configuración de SweetAlert2
const options = {
  confirmButtonColor: '#3085d6',
  cancelButtonColor: '#d33',
};

// Usar SweetAlert2
Vue.use(VueSweetalert2, options);

Vue.config.productionTip = false

store.dispatch('initializeAuth');

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
